import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";

const SOLUTIONS = [
  { title: "Luxury Homes", body: "End-to-end intelligent living for bespoke residences.", image: IMG.villa, cta: "/contact" },
  { title: "Smart Villas", body: "Cinematic lighting, climate and security choreographed.", image: IMG.livingRoom, cta: "/contact" },
  { title: "Apartments", body: "Retrofit-friendly automation for premium apartments.", image: IMG.apartment, cta: "/contact" },
  { title: "Hospitality", body: "Resorts, boutique hotels and serviced experiences.", image: IMG.hotel, cta: "/contact" },
  { title: "Offices", body: "Conference rooms, climate zoning and access control.", image: IMG.office, cta: "/contact" },
  { title: "Retrofit Home Automation", body: "Z-Wave wireless retrofits for existing homes.", image: IMG.retrofit, cta: "/contact" },
  { title: "Interior Solutions", body: "Premium materials, hardware and finishes curated.", image: IMG.interior, cta: "/interior" },
];

export default function Solutions() {
  return (
    <>
      <section className="pt-40 pb-20" data-testid="solutions-hero">
        <div className="container-edge max-w-4xl">
          <p className="eyebrow flex items-center gap-3"><span className="divider-gold" /> Solutions</p>
          <h1 className="display-1 mt-6">
            Solutions for <span className="italic text-gold">intelligent living</span>.
          </h1>
          <p className="mt-8 text-base md:text-lg text-muted-foreground leading-relaxed">
            From luxury villas to hospitality and offices — we tailor world-class automation and curated
            interior solutions to every typology.
          </p>
        </div>
      </section>

      <section className="pb-24 md:pb-32" data-testid="solutions-grid">
        <div className="container-edge space-y-px bg-border">
          {SOLUTIONS.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 80}>
              <div className={`grid lg:grid-cols-12 gap-0 bg-background group ${i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}>
                <div className="lg:col-span-7 aspect-[16/10] lg:aspect-auto overflow-hidden">
                  <img src={s.image} alt={s.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
                </div>
                <div className="lg:col-span-5 p-10 md:p-14 flex flex-col justify-center">
                  <p className="eyebrow">{`0${i + 1}`}</p>
                  <h3 className="display-3 mt-4">{s.title}</h3>
                  <p className="mt-5 text-sm md:text-base text-muted-foreground leading-relaxed">{s.body}</p>
                  <Link to={s.cta} data-testid={`solution-cta-${i}`} className="mt-8 link-underline text-gold w-fit">
                    Discuss Your Project <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
